import { OfferData } from '../../../core/domain/offerData.model'
import OfferService from '../../../core/services/offer.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { MAX_VEHICLES_INSURED } from '../../_utils/environmentConst.provider'
import { getNumberArraySum } from '../../_utils/maths'
import { redirectionProvider } from '../CalculatorRedirection.provider'
import {
  DeductibleSection,
  InsuredAndDeductibleValues,
  View,
} from './Deductible.view'

export class DeductiblePresenter implements LifecyclePresenter<View> {
  private view!: DeductibleSection
  protected offer: OfferData

  private stepPageName: string = 'deductible'
  private stepPageNumber: number = 2

  initialize(view) {
    this.view = view
  }

  getOfferDocument = async () => {
    try {
      this.offer = await OfferService.getOfferData()

      if (
        this.hasChangedNumberOfVehiclesToInsure() &&
        this.offer.progressMask[6] === '1'
      ) {
        for (
          var idx = this.offer.vehiclesToEnsure;
          idx < MAX_VEHICLES_INSURED;
          idx++
        ) {
          this.offer[`insuredVehicle${idx + 1}`] = 0
        }

        await OfferService.saveOfferData(this.offer)
      }
    } catch (error) {
      console.log(error)
    }
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step2-deductible'
    AdobeEventManager.track('calc_step')

    await this.getOfferDocument()

    const platesArray = []
    const insuredArray = []
    Object.keys(this.offer)
      .filter(v => v.startsWith('plate'))
      .map((plate, i) => {
        if (this.offer[`plate${i + 1}`]) {
          platesArray.push(this.offer[`plate${i + 1}`])
          insuredArray.push(
            this.offer[`plate${i + 1}`]
              ? this.offer[`insuredVehicle${i + 1}`]
              : 0,
          )
        }
      })

    const sumInsuredType = this.areAllSameInsured(insuredArray)
      ? 'same'
      : 'different'

    const sumInsured: number =
      sumInsuredType === 'same' ? this.offer.insuredVehicle1 : 0

    this.view.setInitialValues(
      {
        deductible: this.offer.deductible > 0 ? this.offer.deductible : 300,
        sumInsuredType: sumInsuredType,
        sumInsured: sumInsured,
        insuredVehicle1: platesArray[0] ? insuredArray[0] : 0,
        insuredVehicle2: platesArray[1] ? insuredArray[1] : 0,
        insuredVehicle3: platesArray[2] ? insuredArray[2] : 0,
        insuredVehicle4: platesArray[3] ? insuredArray[3] : 0,
        insuredVehicle5: platesArray[4] ? insuredArray[4] : 0,
        totalInsured: this.offer.globalInsured
          ? this.offer.globalInsured
          : getNumberArraySum(insuredArray),
        sumPerVehicle: insuredArray,
      },
      platesArray,
      this.offer.vehiclesToEnsure,
      this.offer.progressMask[6] === '1',
    )
  }

  onContinue = (formValues: InsuredAndDeductibleValues) => {
    this.manageLastVisitedStep(this.stepPageNumber)

    this.offer = this.setFormValues(formValues)
    OfferService.saveOfferData(this.offer).then(() => this.goToNextStep())
  }

  setFormValues = (formValues: InsuredAndDeductibleValues) => {
    const offer = Object.assign(this.offer, {
      ...formValues,
      deductible: Number(formValues.deductible),
    })

    if (formValues.sumInsuredType === 'same') {
      ;[...Array(this.offer.vehiclesToEnsure)].map((_, index) => {
        offer[`insuredVehicle${index + 1}`] = formValues.sumInsured
      })
    }

    if (formValues.sumInsuredType === 'different') {
      ;[...Array(5)].map((_, index) => {
        offer[`insuredVehicle${index + 1}`] =
          formValues[`insuredVehicle${index + 1}`]
      })
    }
    return offer
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(
        this.stepPageName,
        this.offer,
      ),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName, this.offer),
    )
  }

  manageLastVisitedStep = (currentStep: number) => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, currentStep - 1) + '1' + progress.substr(currentStep)
  }

  areAllSameInsured = (insuredArray: any[]) =>
    insuredArray.every((value, index) => {
      if (index > 0) {
        return value === 0 || (value > 0 && value === insuredArray[index - 1])
      }
      return true
    })

  hasChangedNumberOfVehiclesToInsure = () => {
    let insuredVehicles = 0

    for (let idx = 0; idx < MAX_VEHICLES_INSURED; idx++) {
      if (this.offer[`insuredVehicle${idx + 1}`] > 0)
        insuredVehicles = insuredVehicles++
    }

    return insuredVehicles !== this.offer.vehiclesToEnsure
  }
}
